<template>
  <div class="componnet-image-upload">
    <div v-for="(item, index) of imgList" class="img-box" :key="item" @click="handleImgBtnClick(imgList, index)">
      <div class="delete-btn" @click.stop="onDeleteUploadImgClick(index)">
        <van-icon font="18" class="delete-icon" :name="require('../../../assets/imgs/ic_img_delete.png')" />
      </div>
      <van-image
        class="img-show"
        width="72"
        height="72"
        alt="图片"
        :src="ossResize ? `${item}${ossResizeQuery}` : item"
        fit="cover"
      >
        <template v-slot:loading>加载中...</template>
      </van-image>
    </div>

    <template v-if="canShowUploadBtn" style="display: inline-block">
      <van-uploader
        class="upload-btn"
        :deletable="true"
        :after-read="afterRead"
        :beforeRead="beforeRead"
        accept="image/*"
        multiple
      >
        <div class="image-btn-box">
          +
        </div>
      </van-uploader>
    </template>

    <van-image-preview v-model="showPreView" :images="imgList"></van-image-preview>
  </div>
</template>
<script>
import ImageButton from '@/components/ImageButton.vue';
import { ImagePreview } from '@zyf2e/capui-mobile';

export default {
  components: {
    ImageButton
  },
  props: {
    limit: {
      type: Number,
      default: 1
    },
    picSize: {
      type: Number,
      default: 10240 * 1024
    },
    ossResize: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      imgList: [],
      ossResizeQuery: '?x-oss-process=image/resize,m_fill,w_72,h_72',
      showPreView: false
    };
  },
  computed: {
    canShowUploadBtn() {
      return this.imgList.length < this.limit;
    }
  },
  methods: {
    beforeRead(inputFiles) {
      let files = [];
      if (!Array.isArray(inputFiles)) {
        files = [inputFiles];
      }
      if (files.some((file) => !/[jpg|jpeg|png]$/i.test(file.name))) {
        this.$toast('只支持png,jpg图片格式');
        return false;
      }
      if (files.some((file) => file.size > this.picSize)) {
        this.$toast('单张图片不能超过10m');
        return false;
      }
      return true;
    },

    afterRead(files) {
      if (!Array.isArray(files)) {
        files = [files];
      }
      if (files.length + this.imgList.length > 4) {
        this.$toast('最多可上传4张照片哦～');
        return;
      }
      this.uploadFile(files);
    },

    async uploadFile(files) {
      for (let item of files) {
        const file = item.file;
        const formData = new FormData();
        formData.append('scene', 'im_pri_file');
        formData.append('file', file);
        // // dispatchUsploadImg(this.$store, formData)
        // console.log('zzzzzz', file);
        await this.$fetch
          .uploadFileGw(formData)
          .then((resData = {}) => {
            const { fileUrl = ''} = resData;
            if (fileUrl) {
              this.imgList.push(fileUrl);
              this.emitImageChanged();
            } else {
              this.$toast('上传失败，请重试');
            }
          })
          .catch(() => {
            this.$toast('上传失败，请重试');
          });
      }
    },

    onDeleteUploadImgClick(index) {
      this.imgList.splice(index, 1);
      this.emitImageChanged();
    },

    emitImageChanged() {
      this.$emit('handleImageChange', this.imgList);
    },

    handleImgBtnClick(imgs, index) {
      ImagePreview({
        images: imgs,
        startPosition: index
      });
    },
    async onAppUploadClick() {
      const data = await this.adapter.chooseSingleImage();
      if (data.url) {
        this.imgList.push(data.fullPath);
        this.emitImageChanged();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.componnet-image-upload {
  display: flex;
  flex-wrap: wrap;
  .upload-img {
    float: none;
  }
  .img-box {
    position: relative;
    display: inline-block;
    margin: 0 12px 8px 0;
    border-radius: 4px;
    width: 72px;
    height: 72px;
    &:last-child {
      margin-right: 0;
    }
    .delete-btn {
      width: 18px;
      height: 18px;
      position: absolute;
      right: -9px;
      top: -9px;
      background: transparent;
      border-radius: 0 0 0 12px;
      z-index: 100;
      .delete-icon {
        color: #fff;
        font-size: 18px;
      }
    }
    .img-show {
      border-radius: 4px;
      overflow: hidden;
    }
  }
  .image-btn-box {
    width: 72px;
    height: 72px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #BFBFBF;
    font-size: 20px;
  }
  .upload-btn {
    border: 1px dashed #bfbfbf;
    height: 72px;
    border-radius: 4px;
    margin-bottom: 8px;

    ::v-deep.image-box {
      background: #f9faf9;
    }
  }
}
</style>
